<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     账号中心-PC端个性化设置
  +---------------------------------------------------------------------------------------
-->

<template>
  <div class="fam-custom">
    <el-alert v-if="aiot_version == 0" type="warning" :closable="false" class="mt-md">
      <div slot="title" class="flex align-items-center pt-sm pb-sm" style="line-height: 28px;">
        <i class="el-icon-warning font-lg mr-sm"></i>
        <div>当前版本不支持个性化配置，立即升级企业版，尊享更多服务特权</div>
        <el-button type="primary" size="mini" class="ml-sm" @click="$router.push('/home/upgrade')">立即升级</el-button>
      </div>
    </el-alert>
    <el-card v-loading="loading1" shadow="never" class="mt-md mb-md">
      <div class="text-bold font-md">平台个性化</div>
      <el-card shadow="never" :body-style="{ margin: '40px auto', 'max-width': '1200px' }">
        <el-form ref="displayForm" class="display-form" label-position="left" label-width="120px">
          <el-form-item label="平台名称">
            <el-col :span="18">
              <span v-if="customization.console_title">{{ customization.console_title }}</span>
              <span v-else class="text-muted">未设置</span>
            </el-col>
            <el-col :span="6" class="text-right">
              <el-button type="text" :disabled="aiot_version == 0" @click="setConsoleTitle">设置</el-button>
            </el-col>
          </el-form-item>
          <el-form-item label="平台LOGO" :class="customization.console_imgurl&&'logo'">
            <el-col :span="18" style="margin-bottom:5px">
              <span v-if="customization.console_imgurl" class="console-img-container flex-center">
                <el-image :src="customization.console_imgurl" :preview-src-list="[customization.console_imgurl]" fit="contain" style="height:50px;width: 140px;" />
              </span>
              <span v-else class="text-muted">未设置</span>
            </el-col>
            <el-col :span="6" class="text-right" :class="customization.console_imgurl&&'setting'">
              <span class="text-muted font-lg">
                <el-popover placement="top" trigger="hover">
                  推荐图片大小：160 * 160 px<br>
                  推荐图片格式：png
                  <i slot="reference" class="iconfont icon-circle-question"></i>
                </el-popover>
              </span>
              <span class="span">
                <Upload action :file-list="consoleImgFile" :show-file-list="false" :before-upload="beforeConsoleImgUpload" :on-success="setConsoleImg" 
                :disabled="aiot_version == 0" aimPath="custom/" style="display: inline-block;">
                  <el-button type="text" :disabled="aiot_version == 0">设置</el-button>
                </Upload>
              </span>
            </el-col>
          </el-form-item>
        </el-form>
      </el-card>
    </el-card>

    <el-card v-loading="loading2" shadow="never" class="mb-md">
      <div class="text-bold font-md">小程序个性化</div>
      <el-card shadow="never" :body-style="{ margin: '40px auto', 'max-width': '1200px' }">
        <el-form ref="displayForm" class="display-form" label-position="left" label-width="120px">
          <el-form-item label="启动画面">
            <el-col :span="18">
              <div class="preview-container" @click="maskShow = true">
                <el-image v-if="wxapp_customization.startup_screen_id == 1" :src="url1" class="preview" />
                <el-image v-if="wxapp_customization.startup_screen_id == 2 || !wxapp_customization.startup_screen_id" :src="url2" class="preview" />
                <el-image v-if="wxapp_customization.startup_screen_id == -1" :src="wxapp_customization.startup_screen_image_url" class="preview" fit="cover" />
                <div class="slogan1">{{ wxapp_customization.slogan_top || '' }}</div>
                <div class="slogan2 flex-center column">
                  <div class="title">{{ wxapp_customization.slogan || '' }}</div>
                  <div class="des">{{ '鱼漾提供云计算服务' }}</div>
                </div>
              </div>
            </el-col>
            <el-col :span="6" class="text-right">
              <el-button type="text" @click="maskShow = true">预览</el-button>
              <el-button type="text" @click="screenShow = true" :disabled="aiot_version == 0">设置</el-button>
            </el-col>
          </el-form-item>
          <el-form-item label="启动标语">
            <el-col :span="18">
              <span v-if="wxapp_customization.slogan_top">{{ wxapp_customization.slogan_top }}</span>
              <span v-else class="text-muted">未设置</span>
            </el-col>
            <el-col :span="6" class="text-right">
              <el-button type="text" @click="maskShow = true">预览</el-button>
              <el-button type="text" @click="setSloganTop" :disabled="aiot_version == 0">设置</el-button>
            </el-col>
          </el-form-item>

          <el-form-item label="启动底部文字">
            <el-col :span="18">
              <span v-if="wxapp_customization.slogan">{{ wxapp_customization.slogan }}</span>
              <span v-else class="text-muted">未设置</span>
            </el-col>
            <el-col :span="6" class="text-right">
              <el-button type="text" @click="maskShow = true">预览</el-button>
              <el-button type="text" @click="setSlogan" :disabled="aiot_version == 0">设置</el-button>
            </el-col>
          </el-form-item>

        </el-form>
      </el-card>
    </el-card>

    <slogan-preview
      v-if="maskShow"
      :show.sync="maskShow"
      :startup_screen_id="wxapp_customization.startup_screen_id"
      :startup_screen_image_url="wxapp_customization.startup_screen_image_url"
      :slogan="wxapp_customization.slogan"
      :slogan_top="wxapp_customization.slogan_top" />

    <screen-setting 
      v-if="screenShow"
      :show.sync="screenShow" 
      :startup_screen_id="wxapp_customization.startup_screen_id"
      :startup_screen_image_url="wxapp_customization.startup_screen_image_url"
      :slogan="wxapp_customization.slogan"
      :slogan_top="wxapp_customization.slogan_top"  />
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'FamCustom',

  components: {
    Upload: ()=>import('@/components/FUpload'),
    SloganPreview: ()=>import('./components/SloganPreview.vue'),
    ScreenSetting: ()=>import('./components/ScreenSetting.vue'),
  },

  data () {
    return {
      url1: require('@/assets/slogan-preview1.jpg'),
      url2: require('@/assets/slogan-preview2.jpg'),
      
      screenShow: false,
      maskShow: false,
      loading1: false,
      loading2: false,
      consoleImgFile: []
    }
  },

  computed: {
    god () {
      return this.$store.state.godStore
    },

    aiot_version() {
      return this.$store.state.godStore.aiot_version
    },

    customization () {
      if (this.god.customization) {
        return { ...this.god.customization }
      } else {
        return {}
      }
    },

    wxapp_customization () {
      if (this.god.wxapp_customization) {
        return { ...this.god.wxapp_customization }
      } else {
        return {}
      }
    }
  },

  created () {
    this.getCustomizationInfoAction().then(() => {
    }).catch(e => {
      console.log(e)
    })
  },

  methods: {
    ...mapActions([
      'setGodCustomizationAction',
      'getCustomizationInfoAction',
    ]),

    settingDispatch (data) {
      this.$store.dispatch('setGodCustomizationAction', data).then((res) => {
        this.loading1 = false
        this.loading2 = false
        if (!res.errno) {
          this.$message.success(res.message)
        } else {
          this.$message.error(res.message)
        }
      }).catch((err) => {
        console.error(err)
      })
    },

    setSlogan () {
      this.$prompt('', '请输入小程序启动底部文字', {
        inputValue: this.wxapp_customization.slogan,
        inputPlaceholder: '',
        closeOnClickModal: false,
      }).then(({ value }) => {
        this.loading2 = true
        this.settingDispatch({ slogan: value })
      }).catch(() => {
        // 取消
      })
    },

    setSloganTop () {
      this.$prompt('', '请输入小程序启动标语', {
        inputValue: this.wxapp_customization.slogan_top,
        inputPlaceholder: '',
        closeOnClickModal: false,
      }).then(({ value }) => {
        this.loading2 = true
        this.settingDispatch({ slogan_top: value })
      }).catch(() => {
        // 取消
      })
    },

    setConsoleTitle () {
      this.$prompt('', '请输入左上角标题', {
        inputValue: this.customization.console_title,
        inputPlaceholder: '留空则显示默认标题',
        closeOnClickModal: false,
      }).then(({ value }) => {
        this.loading1 = true
        this.settingDispatch({ console_title: value })
      }).catch(() => {
        // 取消
      })
    },

    beforeConsoleImgUpload (file) {
      const formatArr = ['image/jpeg', 'image/png']
      if (formatArr.indexOf(file.type) === -1) {
        this.$message.error('上传图片格式只能是 jpg 或 png！')
        return false
      }
      if (file.size > 2048 * 1024) {
        this.$message.error('上传图片大小不能超过 2M')
        return false
      }
      this.loading1 = true
      return true
    },

    setConsoleImg (response) {
      if (!response.errno) {
        this.settingDispatch({ console_imgurl: response.data.url })
      } else {
        this.loading1 = false
        this.$message.error(response.message)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.fam-custom {
  .console-img-container {
    width: 160px;
    height: 60px;
    background-color: #252a2f;
  }
  .preview-container {
    position: relative;
    width: 72px;
    margin-bottom: 5px;
    height: 140px;
    line-height: 1;
    .slogan1 {
      position: absolute;
      top: 38.2%;
      left: 0;
      right: 0px;
      text-align: center;
      color: #fff;
      font-size: 8px;
      font-style: italic;
      font-weight: 600;
      letter-spacing: 0px;
    }
    .slogan2 {
      position: absolute;
      left: 0;
      right: 0px;
      bottom: 3px;
      height: auto;
      .title {
        font-size: 8px;
        color: #eee;
      }
      .des {
        color: #fff;
        font-size: 5px;
        margin-top: 2px;
        opacity: .5;
      }
    }
    .preview {
      width: 72px;
      height: 140px;
    }
  }
}
/deep/ .logo {
  .el-form-item__label {
    margin-top: 25px;
  }
}
.setting {
  margin-top: 25px;
}
</style>
